import {
  FRAME_INTERVAL_MS,
  FRAME_REST_MS,
  STEP1_FRAMES,
} from "../../../constants/controllerInstruction";
import { useEffect, useRef } from "react";

type TStepImage = {
  src: string | null;
  size: number;
};

const StepImage: React.FC<TStepImage> = (props) => {
  const { src, size } = props;
  const imgRef = useRef<HTMLImageElement>(null);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    STEP1_FRAMES.forEach((frameSrc) => {
      const img = new Image();
      img.src = frameSrc;
    });
  }, []);

  useEffect(() => {
    const clearTimer = () => {
      if (timerRef.current !== null) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };

    clearTimer();

    if (src !== null) {
      if (imgRef.current) imgRef.current.src = src;
      return;
    }

    let frameIndex = 0;
    if (imgRef.current) imgRef.current.src = STEP1_FRAMES[0];

    const scheduleNext = (delay: number) => {
      timerRef.current = setTimeout(tick, delay);
    };

    const tick = () => {
      frameIndex = (frameIndex + 1) % STEP1_FRAMES.length;
      if (imgRef.current) {
        imgRef.current.src = STEP1_FRAMES[frameIndex];
      }

      const isLastFrame = frameIndex === STEP1_FRAMES.length - 1;
      scheduleNext(isLastFrame ? FRAME_REST_MS : FRAME_INTERVAL_MS);
    };

    scheduleNext(FRAME_REST_MS);

    return clearTimer;
  }, [src]);

  return (
    <img
      ref={imgRef}
      src={STEP1_FRAMES[0]}
      width={size}
      alt="step_frames"
      decoding="async"
    />
  );
};

export default StepImage;
